import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TxApiService } from '../../../shared/services/txapi.service';
import { EmployeeDocument, EmployeeDocumentsResponse } from '../../../shared/interfaces/employee-document';

export interface EmployeeDocumentsDialogData {
	employeeId: number;
	employeeName?: string;
	mode: 'teamleader' | 'staff_office';
}

@Component({
	templateUrl: './tx-employee-documents.dialog.component.html',
})
export class TxEmployeeDocumentsDialogComponent implements OnInit {
	loadingDocuments = false;
	hasEmployeeDocuments = false;
	employeeDocuments: EmployeeDocument[] = [];

	constructor(
		private readonly dialogRef: MatDialogRef<TxEmployeeDocumentsDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: EmployeeDocumentsDialogData,
		private readonly apiService: TxApiService
	) {}

	ngOnInit(): void {
		this.loadEmployeeDocuments();
	}

	close(): void {
		this.dialogRef.close();
	}

	loadEmployeeDocuments(): void {
		if (!this.data?.employeeId) {
			this.employeeDocuments = [];
			this.hasEmployeeDocuments = false;
			return;
		}

		this.loadingDocuments = true;

		const requestBody =
			this.data.mode === 'teamleader'
				? { teamleader_for: this.data.employeeId }
				: { staff_office_for: this.data.employeeId };

		this.apiService.callAPI('getEmployeeDocument', requestBody).subscribe(
			(response: EmployeeDocumentsResponse) => {
				this.loadingDocuments = false;
				const documents = response?.ListOfEmployeeDoc ?? [];
				const visibleDocuments =
					this.data.mode === 'teamleader' ? documents.filter((doc) => this.isTeamleaderVisible(doc)) : documents;

				this.employeeDocuments = visibleDocuments;
				this.hasEmployeeDocuments = visibleDocuments.length > 0;
			},
			(error) => {
				this.loadingDocuments = false;
				this.employeeDocuments = [];
				this.hasEmployeeDocuments = false;
				console.error('Error loading employee documents:', error);
			}
		);
	}

	sendEmployeeDocument(document: EmployeeDocument): void {
		if (!document?.document_id) {
			console.error('Invalid document');
			return;
		}
		if (!this.data?.employeeId) {
			console.error('Missing employee id for document request');
			return;
		}

		const docIndex = this.employeeDocuments.findIndex((d) => d.document_id === document.document_id);
		if (docIndex !== -1) {
			this.employeeDocuments[docIndex].loading = true;
		}

		const requestBody =
			this.data.mode === 'teamleader'
				? { document_id: document.document_id, teamleader_for: this.data.employeeId }
				: { document_id: document.document_id, staff_office_for: this.data.employeeId };

		this.apiService.callAPI('sendEmployeeDocument', requestBody).subscribe(
			(response) => {
				if (docIndex !== -1) {
					this.employeeDocuments[docIndex].loading = false;
				}

				if (response?.statuscode === 0) {
					alert(
						'Das Dokument wird Ihnen per E-Mail-Anhang zugesandt.\n\nBitte kontrollieren Sie dazu zeitnah Ihren E-Mail-Eingang.'
					);
				} else {
					console.error('Error sending document:', response);
					alert('Fehler beim Versenden des Dokuments. Bitte versuchen Sie es später erneut.');
				}
			},
			(error) => {
				if (docIndex !== -1) {
					this.employeeDocuments[docIndex].loading = false;
				}
				console.error('Error sending document:', error);
				alert('Fehler beim Versenden des Dokuments. Bitte versuchen Sie es später erneut.');
			}
		);
	}

	private isTeamleaderVisible(document: EmployeeDocument): boolean {
		const value = document?.teamlead_visible;
		return value === 1 || value === 255 || value === true || value === '1' || value === '255';
	}
}
